import { useNavigate } from 'react-router-dom';

import { BootstrapIcon } from '../BootstrapIcon';
import * as choiceApi from '../../api/choice';
import './Reservations.scss';
import { ReserveButton } from './ReserveButton';


export function StatusIcon({
    statusId
}) {
    switch(statusId) {
        case choiceApi.RESERVATION_STATUS_CONFIRMED:
        case choiceApi.RESERVATION_STATUS_PREPAID:
            return(<BootstrapIcon icon="check-lg"/>);

        case choiceApi.RESERVATION_STATUS_PENDING:
            return (<BootstrapIcon icon="hourglass" />)

        case choiceApi.RESERVATION_STATUS_CANCELED:
        case choiceApi.RESERVATION_STATUS_NO_SPACE:
            return (<BootstrapIcon icon="person-slash" />)

        case null:
            return(null)
        
        default:
            return(<BootstrapIcon icon="person" />);
    }
}

export function lookupStatusName(statusId) {
    switch (statusId) {
        case choiceApi.RESERVATION_STATUS_NONE: return 'None';
        case choiceApi.RESERVATION_STATUS_PENDING: return 'Pending';
        case choiceApi.RESERVATION_STATUS_CONFIRMED: return 'Confirmed';
        case choiceApi.RESERVATION_STATUS_ARRIVED: return 'Arrived';
        case choiceApi.RESERVATION_STATUS_CANCELED: return 'Canceled';
        case choiceApi.RESERVATION_STATUS_NO_SPACE: return 'No Space';
        case choiceApi.RESERVATION_STATUS_NO_SHOW: return 'No Show';
        case choiceApi.RESERVATION_STATUS_PREPAID: return 'Prepaid';
        default: return 'None';
    }
}



export function ReservationTable({
    reservation,
    event,
}) {

    const navigate = useNavigate();

    if (!reservation) {
        return null;
    }

    const member = reservation.membershipId ? 
        <tr>
            <td>Member #{reservation.membershipId}</td>
            <td><StatusIcon statusId={reservation.statusId} /> {reservation.statusName}</td>
        </tr>
    :
        <tr>
            <td colSpan={2}>No Reservation</td>
        </tr>
    ;


    const guests = reservation.guests.map((x) => 
        <tr key={`guest-${x.id}`}>
            <td>{x.firstName}</td>
            <td><StatusIcon statusId={x.statusId} /> {x.statusName}</td>
        </tr>
    )


    return (
        <table className="reservation-table">
            <thead>
                <tr>
                    <th>Reservation</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {member}
                {guests}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={2}>
                        <ReserveButton event={event} reservation={reservation} onClick={() => navigate(`${event.id}`)} />
                    </td>
                </tr>
            </tfoot>
        </table>
    );
}
